<template>
    <PopupRouterViewDetail label="Module Info Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Module Information" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-name" label-cols-lg="12"  label="Name" label-for="input-name" size="sm" :model.sync="model.name" :isRequired="true" :state="validateState('name')" :errorMessage="getErrorMessage(errorMessage.name, 'name')"  @change="updateData"  :isUpdatable="true" />
						<app-input-textbox id="fieldset-icon-name" label-cols-lg="12"  label="Icon Name" label-for="input-icon-name" size="sm" :model.sync="model.iconName"  @change="updateData"  :isUpdatable="true" />
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-order-position" label-cols-lg="12" label="Order Position" label-for="input-order-position" size="sm" :thousandSeparator="true" :model.sync="model.orderPosition"  @change="updateData"  :isUpdatable="true" />
						<app-input-combobox-autocomplete :options="moduleInfos" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Parent Module" id="fieldset-parent-module" size="sm" :model.sync="model.parentModuleId"   :selected="model.parentModule != null ? model.parentModule.name : ''" @input="getModuleInfos" @change="updateData"  :isUpdatable="true"  :isSelectMethodExists="true" @onSelectMethod="setSelectedParentModule" />
				</b-col>

            </b-row>
        </b-card>

        <!-- END_APP_DETAIL_HEADER -->

        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import ModuleInfo from '@/models/ModuleInfo/ModuleInfo';
import ModuleInfoList from '@/models/ModuleInfo/ModuleInfoList';
import ModuleInfoFilter from '@/filters/ModuleInfo/ModuleInfoFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputTextbox,
		AppInputComboboxAutocomplete,
		PopupRouterViewDetail,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			name: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				name: { required : "Name is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterModuleInfo : null,
			currentModuleInfoPage : 1,
			moduleInfoPageSize: 10,
			sortByModuleInfo: '',
			sortDescModuleInfo: '',
			moduleInfos: [],
			parentModules: [],
			isParentModuleComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isModuleInfoComboLoading: false,
		}
	},
	methods : {
		getModuleInfo : async function(id) {
			this.isBusy = true;
			ModuleInfo.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadModuleInfo = true;
			this.filterModuleInfo.id = this.modelId;
			ModuleInfo.downloadDataDetail(this, this.filterModuleInfo).then(result => {
				this.isDownloadModuleInfo = false;
			}).catch(error => { this.isDownloadModuleInfo = false; })
		},
		getModuleInfos : async function(input) {
			let filter = new ModuleInfoFilter();
			if (input != undefined) {
				filter.Name = input;
			}
			this.isModuleInfoComboLoading = true;
			ModuleInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.moduleInfos = result.data
				}
				this.isModuleInfoComboLoading = false;
			})
			.catch(error => {});
		},
		getModuleInfos : async function(input) {
			let filter = new ModuleInfoFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ModuleInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.moduleInfos = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedParentModule(item) {
			if(item == undefined || item == null) {
				this.model.parentModuleId = null;
				this.model.parentModule = null;
			} else {
				this.model.parentModuleId = item.id;
				this.model.parentModule = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.moduleInfoInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						ModuleInfo.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'moduleinfoindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						ModuleInfo.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'moduleinfoindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					ModuleInfo.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getModuleInfo(id);
					});
				}
			});
		},
		onHidden() {
			this.getModuleInfos();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterModuleInfo = new ModuleInfoFilter();
		//this.getModuleInfos();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getModuleInfo(id);
			} else {
				this.modelId = id;
				this.getModuleInfo(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
	},
}
</script>
